/*
 * The logic behind path drawing.
 */
import $ from "jquery"
import { pathConfig } from "./pathConfig"

const inRange = (radius, cursorX, cursorY, targetX, targetY) => {
  return (
    Math.abs(cursorX - targetX) <= radius &&
    Math.abs(cursorY - targetY) <= radius
  )
}

const pathDrawing = (fabricCanvas, fabric) => {

  let isDrawingPath = false
  let pathToDraw
  let pointer
  let updatedPath
  let isMouseDown = false
  let isDrawingCurve = false
  let rememberX, rememberY

  fabricCanvas.on("mouse:down", (o) => {

    if (o.target) {
      $(".toolpanel").addClass("visible")
      $("#selectionSelected").css("display", "block")
    }

    if (!fabricCanvas.isDrawingPathMode) return

    isMouseDown = true
    isDrawingPath = true
    pointer = fabricCanvas.getPointer(o.e)

    // PRIMEIRO PONTO
    if (!pathToDraw) {
      pathToDraw = new fabric.Path(
        `M${pointer.x} ${pointer.y} L${pointer.x} ${pointer.y}`,
        {
          strokeWidth: pathConfig.strokeWidth,
          stroke: pathConfig.stroke,
          fill: false,
          selectable: false,
          evented: false,
          strokeUniform: true,
        }
      )

      fabricCanvas.add(pathToDraw)
      return
    }

    // NOVO SEGMENTO
    pathToDraw.path.push(["L", pointer.x, pointer.y])

    let dims = pathToDraw._calcDimensions()
    pathToDraw.set({
      width: dims.width,
      height: dims.height,
      left: dims.left,
      top: dims.top,
      pathOffset: {
        x: dims.width / 2 + dims.left,
        y: dims.height / 2 + dims.top,
      },
      dirty: true,
    })

    pathToDraw.setCoords()
    fabricCanvas.renderAll()
  })

  fabricCanvas.on("mouse:move", (o) => {
    if (!fabricCanvas.isDrawingPathMode) return
    if (!isDrawingPath) return

    pointer = fabricCanvas.getPointer(o.e)

    if (!isDrawingCurve) {
      updatedPath = ["L", pointer.x, pointer.y]
    }

    pathToDraw.path.pop()

    // SHIFT → SNAP ANGLE
    if (o.e.shiftKey && !isDrawingCurve) {
      let lastPoint = [...pathToDraw.path].pop()
      let startX = lastPoint[1]
      let startY = lastPoint[2]

      let x2 = pointer.x - startX
      let y2 = pointer.y - startY
      let r = Math.sqrt(x2 * x2 + y2 * y2)
      let angle = (Math.atan2(y2, x2) * 180) / Math.PI

      angle = Math.round(angle / 15) * 15

      updatedPath[1] = Math.cos((angle * Math.PI) / 180) * r + startX
      updatedPath[2] = Math.sin((angle * Math.PI) / 180) * r + startY
    }

    // SNAP EM PONTOS EXISTENTES
    if (pathToDraw.path.length > 1 && !isDrawingCurve) {
      let snapPoints = [...pathToDraw.path]
      snapPoints.pop()

      for (let p of snapPoints) {
        if (
          (p[0] === "L" || p[0] === "M") &&
          inRange(10, pointer.x, pointer.y, p[1], p[2])
        ) {
          updatedPath[1] = p[1]
          updatedPath[2] = p[2]
          break
        }

        if (
          p[0] === "Q" &&
          inRange(10, pointer.x, pointer.y, p[3], p[4])
        ) {
          updatedPath[1] = p[3]
          updatedPath[2] = p[4]
          break
        }
      }
    }

    // CURVAS
    if (isMouseDown) {
      if (!isDrawingCurve && pathToDraw.path.length > 1) {
        isDrawingCurve = true
        let lastPath = pathToDraw.path.pop()

        if (lastPath[0] === "Q") {
          updatedPath = ["Q", lastPath[3], lastPath[4], lastPath[3], lastPath[4]]
          rememberX = lastPath[3]
          rememberY = lastPath[4]
        } else {
          updatedPath = ["Q", lastPath[1], lastPath[2], lastPath[1], lastPath[2]]
          rememberX = lastPath[1]
          rememberY = lastPath[2]
        }
      } else if (isDrawingCurve) {
        let mouseMoveX = pointer.x - updatedPath[3]
        let mouseMoveY = pointer.y - updatedPath[4]

        updatedPath = [
          "Q",
          rememberX - mouseMoveX,
          rememberY - mouseMoveY,
          rememberX,
          rememberY,
        ]
      }
    }

    pathToDraw.path.push(updatedPath)

    let dims = pathToDraw._calcDimensions()
    pathToDraw.set({
      width: dims.width,
      height: dims.height,
      left: dims.left,
      top: dims.top,
      pathOffset: {
        x: dims.width / 2 + dims.left,
        y: dims.height / 2 + dims.top,
      },
      dirty: true,
    })

    fabricCanvas.renderAll()
  })

  fabricCanvas.on("mouse:up", (o) => {
    if (!fabricCanvas.isDrawingPathMode) {
      isMouseDown = false
      isDrawingCurve = false
      return
    }

    isMouseDown = false

    if (isDrawingCurve) {
      pointer = fabricCanvas.getPointer(o.e)
      pathToDraw.path.push(["L", pointer.x, pointer.y])

      let dims = pathToDraw._calcDimensions()
      pathToDraw.set({
        width: dims.width,
        height: dims.height,
        left: dims.left,
        top: dims.top,
        pathOffset: {
          x: dims.width / 2 + dims.left,
          y: dims.height / 2 + dims.top,
        },
        dirty: true,
      })

      pathToDraw.setCoords()
      fabricCanvas.renderAll()
    }

    isDrawingCurve = false
  })

  /* =========================
     CANCEL DRAWING
  ========================== */
  const cancelDrawing = () => {
    pathToDraw.path.pop()

    if (pathToDraw.path.length > 1) {
      let dims = pathToDraw._calcDimensions()
      pathToDraw.set({
        width: dims.width,
        height: dims.height,
        left: dims.left,
        top: dims.top,
        pathOffset: {
          x: dims.width / 2 + dims.left,
          y: dims.height / 2 + dims.top,
        },
        dirty: true,
      })
    } else {
      fabricCanvas.remove(pathToDraw)
    }

    fabricCanvas.renderAll()
    fabricCanvas.trigger("object:modified")

    pathToDraw = null
    isDrawingPath = false
  }

  document.addEventListener("keydown", (e) => {
    if (!isDrawingPath) return
    if ((e.which || e.keyCode) === 27) cancelDrawing()
  })

  document.addEventListener("mousedown", (e) => {
    if (!isDrawingPath) return
    if (!document.querySelector(".canvas-container")?.contains(e.target)) {
      cancelDrawing()
    }
  })
}

export default pathDrawing
